import React from 'react';
import '../App.css';

function ContactMe() {
    return (
        <h1 className="contactme">CONTACT ME</h1>
    )
}

export default ContactMe